<template>
  <!--  -->
  <div class="print-report-page show-in-print">
    <div v-for="(page, pageIndex) in paginatedItems" :key="pageIndex">
      <div>
        <div>{{ pageIndex + 1 }}</div>

        <div class="flex justify-center flex-col items-center">
          <h1>فناوران آواسیس</h1>
          <h5 class="mt-3">صورت هزینه تنخواه واحد بازرگانی</h5>
        </div>
        <div>
          <div class="flex gap-4">
            <span>تاریخ :</span>
            <span>{{ iranDate }}</span>
          </div>
          <div class="flex gap-4">
            <span>شماره :</span>
            <span></span>
          </div>
        </div>
        <table class="basic-tbl mt-5">
          <thead>
            <tr>
              <th >ردیف</th>
              <th >{{ $t("VoucherCode") }}</th>
              <th >{{ $t("Date") }}</th>
              <th>{{ $t("Description") }}</th>
              <th >{{ $t("Debtor") }}</th>
              <th >{{ $t("Creditor") }}</th>
              <th >{{ $t("Balance") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, itemIndex) in page" :key="itemIndex">
              <td style="width: 3%">
                {{ itemIndex + 1 }}
              </td>
              <td style="width: 8%">
                {{ row.voucherId }}
              </td>
              <td style="width: 15%; direction: ltr">
                {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
              </td>
              <td style="width: 30%">
                {{ row.description ? row.description : "-" }}
              </td>
              <td style="width: 15%">
                {{ formatPrice(row.debtor) }}
              </td>
              <td style="width: 15%">
                {{ formatPrice(row.creditor) }}
              </td>
              <td style="width: 15%">
                {{ formatPrice(row.remaining) }}
              </td>
            </tr>
          </tbody>
        </table>
        <table class="basic-tbl border-t-0">
          <thead>
            <!-- <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>{{ $t("sumOfDebtor") }}</th>
              <th >{{ $t("sumOfCreditor") }}</th>
              <th>{{ $t("sumOfBalance") }}</th>
            </tr> -->
          </thead>
          <tbody>
            <tr>

              <td style="width: 58%">
                {{ $t("Sum") }}
                
              </td>
              <td style="width: 14%">
                {{ formatPrice(reportData.sumOfDebtor) }}
              </td>
              <td style="width: 15%">
                {{ formatPrice(reportData.sumOfCreditor) }}
              </td>
              <td style="width: 15%">
                {{formatPrice(reportData.sumOfRemaining)  }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="flex gap-4 mt-6 mx-5 end-page">
          <div class="w-1/3">
            <span>تهیه کننده</span>
          </div>
          <div class="w-1/3">
            <span>ثبت کننده</span>
          </div>
          <div class="w-1/3">
            <span>تایید کننده</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  data() {
    return {
      iranDate: "",
      reportArray:[],
      sumOf:{}
    };
  },
  props: {
    reportData: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.iranDate = moment().locale("fa").format("jYYYY/jM/jD");
    this.reportArray=[
              {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 200000000000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    },
    {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 2000.00000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    },
    {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 2000.00000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    },
    {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 2000.00000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    },    {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 2000.00000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    },    {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 2000.00000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    },    {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 2000.00000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    },    {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 2000.00000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    },    {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 2000.00000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    },    {
        "voucherId": 36,
        "createOn": "1403-10-17",
        "description": "بابت شارژ",
        "debtor": 2000.00000,
        "creditor": 0.0,
        "remaining": 2000.00000
    },
    {
        "voucherId": 37,
        "createOn": "1403-10-17",
        "description": "بابت هزینه اسنپ",
        "debtor": 0.0,
        "creditor": 100.00000,
        "remaining": 1900.00000
    },
    {
        "voucherId": 38,
        "createOn": "1403-10-17",
        "description": "بابت هزینه رستوران",
        "debtor": 0.0,
        "creditor": 50.00000,
        "remaining": 1850.00000
    },
    {
        "voucherId": 39,
        "createOn": "1403-10-17",
        "description": "هزینه ماشین",
        "debtor": 0.0,
        "creditor": 90.00000,
        "remaining": 1760.00000
    },
    {
        "voucherId": 40,
        "createOn": "1403-10-18",
        "description": "شارژ دوباره",
        "debtor": 1000.00000,
        "creditor": 0.0,
        "remaining": 2760.00000
    }
  ]

  },
  computed: {
    paginatedItems() {
      const itemsPerPage = 20;
      const pages = [];
      for (let i = 0; i < this.reportArray.length; i += itemsPerPage) {
        if(this.reportArray){
          pages.push(this.reportArray.slice(i, i + itemsPerPage));

        }
      }
      return pages;
    },
  },

  methods: {
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

  },
};
</script>
